function handleBSCard() {
  // Handle BS cards
  const bsCards = $("[data-custom-products] .bs-product-card-v2__card");
  handleCards(bsCards, false);

  // Handle Sale cards
  const saleCards = $("[data-sale-products] .bs-product-card-v2__card");
  handleCards(saleCards, true);
}

function handleCards(cards, isSale) {
  cards.each(function () {
    const $card = $(this);
    const $addToCartBtn = $card.find("#is-bs-product-atc-btn");
    const $sideShieldToggleInput = $card.find(
      ".is-bs-product-sideshield-toggle"
    );
    const $productImage = $card.find(
      ".bs-product-card-v2__card-image:not(#is-bs-product-shield-image)"
    );
    const $sideShieldImage = $card.find("#is-bs-product-shield-image");
    const $currentPriceElem = $card.find("#is-bs-product-price");
    const $reviewLink = $card.find("#sandlane-main-review-widget");
    const $productLink = $card.find(
      ".bs-product-card-v2__card-image-wrapper a"
    );
    const $alertMessage = $card.find(".custom-alert-message");

    const currentPrice = isSale
      ? $card.attr("data-sale-variant-price")
      : $card.attr("data-bs-variant-price");
    const sideShieldPrice = isSale
      ? $card.attr("data-sale-side-shield-price")
      : $card.attr("data-bs-side-shield-price");
    const productId = isSale
      ? $card.attr("data-sale-product-id")
      : $card.attr("data-bs-product-id");
    const sideShieldId = isSale
      ? $card.attr("data-sale-side-shield-id")
      : $card.attr("data-bs-side-shield-id");

    let isSideShieldEnabled = false;

    function updatePrice(isShieldEnabled) {
      // Get base prices from data attributes
      const basePrice = parseInt(currentPrice) || 0;
      const shieldPrice = parseInt(sideShieldPrice) || 0;

      // Calculate new price
      const newPrice = isShieldEnabled ? basePrice + shieldPrice : basePrice;

      // Update sale price
      $currentPriceElem.find(".bfcm-sale-price").text("$" + newPrice);

      // Check if compare at price element exists
      const $comparePrice = $currentPriceElem.find(".bfcm-compare-at-price");
      if ($comparePrice.length > 0) {
        const originalComparePrice =
          parseInt($card.attr("data-bs-variant-compare-price")) || basePrice;
        const originalShieldComparePrice =
          parseInt($card.attr("data-bs-side-shield-compare-price")) ||
          shieldPrice;

        // Calculate total compare at price including side shields if enabled
        const totalComparePrice = isShieldEnabled
          ? originalComparePrice + originalShieldComparePrice
          : originalComparePrice;

        if (totalComparePrice > newPrice) {
          $comparePrice.text("$" + totalComparePrice + " ");
        }
      }
    }

    function toggleImages(isShieldEnabled) {
      if (isShieldEnabled) {
        // Check if side shield image exists and has valid src
        const hasValidShieldImage =
          $sideShieldImage.length > 0 &&
          $sideShieldImage.attr("src") &&
          $sideShieldImage.attr("src").trim() !== "";

        if (!hasValidShieldImage) {
          // Show alert message if no valid side shield image
          $alertMessage.removeClass("hide-this");
          $productImage.removeClass("hide-this");
          $sideShieldImage.addClass("hide-this");
        } else {
          // Hide main image and show side shield image
          $productImage.addClass("hide-this");
          $sideShieldImage.removeClass("hide-this");
          $alertMessage.addClass("hide-this");
        }
      } else {
        // Reset to original state
        $productImage.removeClass("hide-this");
        $sideShieldImage.addClass("hide-this");
        $alertMessage.addClass("hide-this");
      }
    }

    function updateLinks(isShieldEnabled) {
      const linksToUpdate = [$reviewLink, $productLink];

      linksToUpdate.forEach(($link) => {
        if ($link.length) {
          let href = $link.attr("href");

          if (href.includes("#")) {
            const [mainUrl, hashPart] = href.split("#");
            const urlParts = mainUrl.split("?");
            const baseUrl = urlParts[0];
            const params = new URLSearchParams(urlParts[1]);

            if (isShieldEnabled) {
              params.set("addons", "sideshields");
            } else {
              params.delete("addons");
            }

            href = `${baseUrl}${
              params.toString().length > 0 ? "?" + params.toString() : ""
            }#${hashPart}`;
          } else {
            const urlParts = href.split("?");
            const baseUrl = urlParts[0];
            const params = new URLSearchParams(urlParts[1]);

            if (isShieldEnabled) {
              params.set("addons", "sideshields");
            } else {
              params.delete("addons");
            }

            href = `${baseUrl}${
              params.toString().length > 0 ? "?" + params.toString() : ""
            }`;
          }

          $link.attr("href", href);
        }
      });
    }

    $sideShieldToggleInput.on("change", function () {
      const $this = $(this);
      const cardType = $this.data("card-type");
      const variantId = $this.data("variant-id");

      // Only handle if it matches the card type
      if (
        (isSale && cardType === "sale") ||
        (!isSale && cardType === "bestseller")
      ) {
        isSideShieldEnabled = $this.is(":checked");
        toggleImages(isSideShieldEnabled);
        updatePrice(isSideShieldEnabled);
        updateLinks(isSideShieldEnabled);
      }
    });

    $addToCartBtn.on("click", async function () {
      try {
        const items = isSideShieldEnabled
          ? [{ id: productId }, { id: sideShieldId }]
          : [{ id: productId }];

        await OmbrazUtils.v2AddToCart(items, { button: this });
      } catch (error) {
        console.error("Error adding to cart:", error);
      }
    });
  });
}

$(document).ready(handleBSCard);
